var modules = {
  registry: {},
  entities: {}, // mapping of entity:name of module
  appPaths: {}
};
var moduleRegistry = modules;

modules.registerEntity = function(entityName, moduleName) {
  modules.entities[entityName.toLowerCase()] = moduleName;
};

modules.getModuleByEntity = function(entityName) {
  if (entityName) {
    return modules.entities[entityName.toLowerCase()];
  } else {
    return null;
  }
};

modules.getModuleSettings = function(moduleName, variable) {
  // console.debug("MODULE SETTINGS for "+moduleName+" "+variable);
  var module = modules.registry[moduleName];

  if (module) {
    if (module[variable]) {
      return module[variable];
    } else {
      console.error(
        'Module variable ' + moduleName + '.' + variable + ' not found '
      );
    }
  } else {
    if (modules.default[variable]) {
      return modules.default[variable];
    }
  }
  return '';
};

modules.getModuleSettingsByEntity = function(entityName, variable) {
  return modules.getModuleSettings(
    modules.getModuleByEntity(entityName),
    variable
  );
};

modules.initModules = function(afterFunc, data) {
  modules.default = {
    popupPath: null,
    iconPath: null,
    corePath: '',
    coreGenPath: '',
    jsPath: 'app/',
    jsGenPath: 'app/'
  };

  //in case no data is set, return immediately (only expected while developing)
  if (!data) {
    console.error('modules.initModules got called with no data');
    return;
  }

  if (!app.credentials.loggedIn) {
    console.log('modules not loading, user not logged in');
    afterFunc();
    return;
  }

  console.debug('modules loading', afterFunc);
  modules.afterLoadingFinished = afterFunc;

  // load modules
  modules.registry = data;
  $.each(modules.registry, function(name, module) {
    console.debug('Loading  ', module);
    modules.moduleLoaded(name);
  });

  // if no modules are existing just init directly
  if (modules.isLoadingFinished()) {
    modules.afterLoadingFinished();
  }
};

modules.isLoadingFinished = function() {
  var loaded = true;
  for (var m in modules.registry) {
    var module = modules.registry[m];
    if (!module.loaded) {
      loaded = false;
    }
  }
  console.debug('Loading finished ', loaded, modules);
  return loaded;
};

modules.moduleLoaded = function(moduleName) {
  console.debug('Module loaded', moduleName);
  var m = modules.registry[moduleName];
  m.loaded = true;

  $.each(m.apps, function(key, appList) {
    if (!modules.appPaths[key]) {
      modules.appPaths[key] = [];
    }
    $.each(appList, function(_k, app) {
      modules.appPaths[key].push(app);
    });
  });

  if (modules.isLoadingFinished()) {
    modules.afterLoadingFinished();
  }
};

modules.afterLoadingFinished = function() {
  console.debug(' all modules loaded ');
};

app.getModuleSettings = modules.getModuleSettings;

global.moduleRegistry = moduleRegistry;
global.modules = modules;
